<template>
  <b-container>
    <div v-if="loadError" class="text-danger user-load-error">{{$t('user_load_error')}}
      <b-button class="user-load-retry" type="button" :disabled="isBusy" @click="loadData">{{$t('retry')}}</b-button>
    </div>
    <span v-if="dataLoaded">
      <ValidationObserver ref="userUpdateForm" v-slot="{ invalid }">
      <b-form
          @submit.prevent="onSubmit"
      >
      <fieldset :disabled="saving || isBusy">
        <validation-provider vid="organisationId" v-slot="{ errors }" rules="required" >
          <b-form-group
              label-for="organisation"
              :label="$t('user.create.organisation')"
          >
            <b-form-select
                id="organisation"
                v-model="form.organisationId"
                placeholder="organisation"
                :options="organisationList"
                value-field="id"
                text-field="name"
            />
            <span class="text-danger">{{ errors[0] }}</span>
          </b-form-group>
        </validation-provider>
        <validation-provider vid="type" v-slot="{ errors }" rules="required" >
          <b-form-group
              label-for="type"
              :label="$t('user.create.type')"
          >
            <b-form-select
                id="type"
                :options="typeList"
                value-field="id"
                text-field="name"
                v-model="form.type"
                :placeholder="$t('user.create.type.placeholder')"
            >
            </b-form-select>

            <span class="text-danger">{{ errors[0] }}</span>
          </b-form-group>
        </validation-provider>
          <validation-provider
              vid="login" v-slot="{ errors }" rules="required|min:3|max:50|loginUpdate" >
          <b-form-group
              label-for="login"
              :label="$t('user.create.login')"
          >
            <b-input
                id="login"
                v-model="form.login"
                :placeholder="$t('user.create.login.placeholder')"
                :disabled="isAllUsersEdit()"
            >
            </b-input>
<span class="text-danger">{{ errors[0] }}</span>
          </b-form-group>
              </validation-provider>
        <validation-provider vid="password" v-slot="{ errors }" rules="min:5|max:255|password" >
          <b-form-group
              label-for="password"
              :label="$t('user.create.password')"
          >
            <b-input
                id="password"
                type="password"
                v-model="form.password"
                :aria-describedby="$t('user.update.password.help')"
                :placeholder="$t('user.create.password.placeholder')"
            >
            </b-input>
            <b-form-text id="password-help-block">
              {{$t('user.update.password.help')}}
            </b-form-text>

            <span class="text-danger">{{ errors[0] }}</span>
          </b-form-group>
        </validation-provider>
        <validation-provider vid="name" immediate v-slot="{ errors }" rules="required|unicodeLength:5,255|userName" >
          <b-form-group
              label-for="name"
              :label="$t('user.create.name')"
          >
            <b-input
                id="name"
                @input="validate"
                v-model="form.name"
                :placeholder="$t('user.create.name')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
          </b-form-group>
        </validation-provider>
        <validation-provider vid="phone" immediate v-slot="{ errors }" rules="required|phone" >
          <b-form-group
              label-for="phone"
              :label="$t('user.create.phone')"
          >
            <b-input
                id="phone"
                v-model="form.phone"
                :placeholder="$t('user.create.phone')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
          </b-form-group>
        </validation-provider>
        <validation-provider vid="email" immediate v-slot="{ errors }" rules="required|email" >
          <b-form-group
              label-for="email"
              :label="$t('user.create.email')"
          >
            <b-input
                id="email"
                v-model="form.email"
                :placeholder="$t('user.create.password.email')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
          </b-form-group>

        </validation-provider>
        <b-form-group>
          <b-form-checkbox
              v-model="form.isActive"
          >
            {{$t('user.update.is_active')}}
          </b-form-checkbox>
        </b-form-group>
        <div v-if="responseError" class="text-danger user-save-error">
          {{$t('saved_error')}} <br>
          {{responseErrorMessage}}
        </div>
        <span v-if="updated">
        <div>
          {{$t('saved_successful')}}
        </div>
      </span>

        <b-button
            :disabled="invalid || saving || isBusy || loadError"
            type="submit"
            variant="primary"
        >{{$t('user.update')}}</b-button>
      </fieldset>
    </b-form>
    </ValidationObserver>
    </span>
  </b-container>
</template>

<script>
import axios from "axios";
import { saveForm } from "../../utils/SaveForm";
import { isRouteId, isUserPayloadValid } from "../../utils/FormValidation";
import { REQUEST_TIMEOUT_MS } from "../../utils/RequestGuard";

export default {
  name: "Edit",
  props: {
    id: { required: true},
  },
  data() {
    return {
      isBusy: true, loadError: false, saving: false, disposed: false, requestVersion: 0, readVersion: 0,
      dataLoaded: false,
      organisationList: [],
        allUsersEdit: false,
      typeList: [
        {id: 'admin', name: 'admin'},
        {id: 'user', name: 'user'}
      ],
      form: {
        organisationId: null,
        type: null,
        login: null,
        password: null,
        name: null,
        phone: null,
        email: null,
        isActive: null
      },
      responseError: false,
      responseErrorMessage: null,
      updated: false
    }
  },
  methods: {
    onSubmit() {
      if (this.isBusy || this.loadError || !this.dataLoaded || !isRouteId(Number(this.id))) return;
      const payload = { ...this.form, password: this.form.password === '' ? null : this.form.password };
      return saveForm(this, { method: 'post', url: 'api/v1/users/' + this.id, payload,
        observer: 'userUpdateForm', success: 'updated', event: 'onUpdated',
        fields: ['organisationId', 'type', 'login', 'password', 'name', 'phone', 'email', 'isActive'],
        validPayload: value => isUserPayloadValid(value, true, this.organisationList.map(item => item.id)),
      });
    },
    async loadData() {
      if (this.disposed || !isRouteId(Number(this.id))) return;
      const request = ++this.readVersion;
      this.requestVersion++; this.saving = false; this.isBusy = true; this.loadError = false; this.responseError = false;
      this.updated = false;
      this.dataLoaded = false;
      const id = Number(this.id);
      try {
        const [userResponse, organisations] = await Promise.all([
          axios.get('api/v1/users/' + id, { timeout: REQUEST_TIMEOUT_MS }),
          axios.get('api/v1/users/distibutors', { timeout: REQUEST_TIMEOUT_MS }),
        ]);
        if (this.disposed || request !== this.readVersion) return;
        const user = userResponse.data;
        if (!Array.isArray(organisations.data.rows) || !isRouteId(user.organisation?.id)
          || typeof user.type?.name !== 'string' || typeof user.isActive !== 'boolean') throw new Error('Invalid user card');
        this.organisationList = organisations.data.rows;
        this.form = { organisationId: user.organisation.id, type: user.type.name.toLowerCase(),
          login: user.login, password: null, name: user.name, phone: user.phone, email: user.email, isActive: user.isActive };
        this.dataLoaded = true;
      } catch (error) {
        if (!this.disposed && request === this.readVersion && error.response?.status !== 401) this.loadError = true;
      } finally { if (!this.disposed && request === this.readVersion) this.isBusy = false; }
    },
      isAllUsersEdit() {
        return !this.allUsersEdit;
      },
    validate() {
      this.$refs.userUpdateForm.validate();
    },
      initFutureAvailable() {
          let futureAvailable = {};

          if (localStorage.getItem('futureAvailable')) {
              try {
                  futureAvailable = JSON.parse(localStorage.getItem('futureAvailable'));
              } catch(e) {
                  localStorage.removeItem('futureAvailable');
                  return;
              }
          }


          this.allUsersEdit = futureAvailable?.allUsersEdit === true;
      },
  },
  mounted() { this.initFutureAvailable(); this.loadData(); },
  watch: { id() { this.requestVersion++; this.readVersion++; this.dataLoaded = false; this.saving = false; this.loadData(); } },
  beforeDestroy() { this.disposed = true; this.requestVersion++; this.readVersion++; },
}
</script>

<style scoped>

</style>